<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Portlet from '@src/components/portlet'
import PaymentRequestService from '@services/resources/PaymentRequestService'
import Money from '@src/mixins/money'
import Filters from '@components/payments/filters'
import _ from 'lodash'
import ModalDetails from './modal-details.vue'
import ProductService from '@services/resources/ProductService'
var service2 = ProductService.build()

var service = PaymentRequestService.build()

/**
 * Dashboard-4 component
 */
export default {
  page: {
    title: 'Requisições',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Portlet, Filters, ModalDetails },
  mixins: [Money],
  data() {
    return {
      title: 'Requisições',
      requests: [],
      productid: null,
      solicitation: {},
      loading: true,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Requisições',
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      total: 0,
      totalToPaid: 0,
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: '',
      filterOn: [],
      filters: {},
      sortBy: 'name',
      sortDesc: false,
      columns: [
        { key: 'id', label: 'ID', sortable: true },
        { key: '_client', label: 'Dados do Cliente', sortable: false },
        { key: '_product', label: 'Produto', sortable: false },
        { key: '_event', label: 'Evento', sortable: false },
        { key: '_method', label: 'Método', sortable: false },
        { key: '_amount', label: 'Valor Total', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
    }
  },
  watch: {
    currentPage() {
      this.fetchRequisitions()
    },
    perPage() {
      this.fetchRequisitions()
    },
    filter() {
      this.fetchRequisitions({ search: this.filter })
    },
  },
  mounted() {
    this.fetchRequisitions()
  },
  methods: {
    open(e) {
      const id = e.request.product_id || e.request.products[0].product_id
      if (id) {
        this.productid = id
        setTimeout(() => {
          this.$bvModal.show('details2')
        })
      } else {
        this.$bvToast.toast('ID deste produto está incorreto', {
          title: 'Produto / Requisições',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        })
      }
    },
    posFilters(filters) {
      this.filters = filters
      this.fetchRequisitions(this.filters)
    },
    fetchRequisitions(filters = {}) {
      this.loading = true
      this.requests = []

      let data = {}

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.filter.length) data.search = this.filter

      service
        .search(data)
        .then((resp) => {
          this.requests = resp
          this.loading = false
        })
        .catch((err) => {})
    },
    update(data) {
      service
        .update(data)
        .then((resp) => {
          this.fetchRequisitions()
        })
        .catch((err) => {
          console.log(err.response.data)
          this.$bvToast.toast(err.response.data.error, {
            title: 'Requisições',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: true,
          })
        })
    },
    processAll(status) {
      Vue.swal({
        title: 'Processar todas as requisição',
        text: 'Tem certeza que deseja fazer isso?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let ids = this.requests.map((elem) => {
            return elem.id
          })

          let data = {
            ids: ids,
            id: 1,
            status: status,
          }
          this.update(data)
        }
      })
    },
    accept(id) {
      Vue.swal({
        title: 'Reprocessar requisição',
        text: 'Tem certeza que deseja reprocessar essa requisição?',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            ids: [id],
            id: id,
            status: 'ACCEPTED',
          }

          this.update(data)
        }
      })
    },
    deny(id) {
      Vue.swal({
        title: 'Recusar requisição',
        text: 'Tem certeza que deseja recusar essa solicitação de reembolso?',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Reprovar',
        showLoaderOnConfirm: true,
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value.length) {
          let data = {
            ids: [id],
            id: 1,
            status: 'DENIED',
          }
          this.update(data)
        }
      })
    },
  },
}
</script>
<template>
  <div>
    <Filters @close="posFilters" />
    <PageHeader :title="title" :items="items" />
    <ModalDetails :productid="productid" />
    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="row align-items-center">
                <b-button v-b-modal.modal-filters variant="success" size="sm"
                  >Filtros</b-button
                >

                <b-button
                  variant="dark"
                  size="sm"
                  class="ml-2"
                  @click="fetchRequisitions(filters)"
                  >Recarregar</b-button
                >

                <b-button
                  variant="success"
                  size="sm"
                  class="ml-2"
                  @click="processAll('ACCEPTED')"
                  >Aprovar todas</b-button
                >

                <b-button
                  variant="danger"
                  size="sm"
                  class="ml-2"
                  @click="processAll('DENIED')"
                  >Recusar todas</b-button
                >
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Pesquisar..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div
                v-if="requests.length > 0 && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  :items="requests"
                  :fields="columns"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  :filter-included-fields="filterOn"
                >
                  <!-- :filter="filter" -->

                  <!-- <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template> -->

                  <template v-slot:cell(_product)="data">
                    <div>
                      <b class="mr-1">Tipo:</b>
                      <span>{{
                        data.item.request.type === 'TRANSACTION'
                          ? 'Valor único'
                          : 'Assinatura'
                      }}</span>
                    </div>
                    <div>
                      <b class="mr-1">Valor produto:</b>
                      <span
                        >R$ {{ formatMoney(data.item.request.amount) }}</span
                      >
                    </div>
                    <div>
                      <b class="mr-1">ID Produto:</b>
                      <span>{{
                        data.item.request.product_id ||
                        data.item.request.products[0].product_id
                      }}</span>
                    </div>
                    <div
                      v-if="
                        data.item.request.proposal_id ||
                        data.item.request.products[0].proposal_id
                      "
                    >
                      <b class="mr-1">ID Proposta:</b>
                      <span>{{
                        data.item.request.proposal_id ||
                        data.item.request.products[0].proposal_id
                      }}</span>
                    </div>
                  </template>
                  <template v-slot:cell(_event)="data">
                    <div>
                      <b class="mr-1">Data:</b>
                      <span>{{ data.item.created_at | datetime }}</span>
                    </div>

                    <div>
                      <b class="mr-1">Motivo:</b>
                      <span>{{ data.item.reason }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(_client)="data">
                    <div>
                      <b class="mr-1">Nome:</b>
                      <span>{{ data.item.request.name }}</span>
                    </div>
                    <div>
                      <b class="mr-1">CPF:</b>
                      <span>{{ data.item.request.cpf_cnpj }}</span>
                    </div>
                    <div>
                      <b class="mr-1">Email:</b>
                      <span>{{ data.item.request.email }}</span>
                    </div>
                    <div>
                      <b class="mr-1">Telefone:</b>
                      <span>{{ data.item.request.cellphone }}</span>
                    </div>
                    <div>
                      <b class="mr-1">IP:</b>
                      <span>{{ data.item.ip }}</span>
                    </div>
                    <div
                      v-b-tooltip="{
                        title: data.item.user_agent,
                        placement: 'top',
                      }"
                    >
                      <b class="mr-1">UserAgent:</b>
                      <span>{{
                        data.item.user_agent.length > 30
                          ? data.item.user_agent.substr(0, 30) + '...'
                          : data.item.user_agent
                      }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(_amount)="data">
                    R$ {{ formatMoney(data.item.request.total || 0) }}
                  </template>

                  <template v-slot:cell(_method)="data">
                    <div
                      v-b-tooltip="{
                        title: data.item.request.method,
                        placement: 'top',
                      }"
                    >
                      <PaymentMethodIcon :method="data.item.request.method" />
                    </div>
                  </template>

                  <template v-slot:cell(_actions)="data">
                    <b-button
                      variant="success"
                      class="mr-2"
                      @click="accept(data.item.id)"
                    >
                      <i class="fas fa-check"></i>
                    </b-button>
                    <b-button
                      variant="primary"
                      class="mr-2"
                      @click="open(data.item)"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="deny(data.item.id)"
                    >
                      <i class="fas fa-times"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div
            v-if="requests.length == 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-primary" role="alert">
              Sem requisições pendentes.
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

